import axios from "axios";
import 'bootstrap';
import $ from 'jquery';
import Popper from 'popper.js';

const temp = 1;
let input = document.getElementById("searchUser");
if (input)
    input.addEventListener("keyup", function (event) {
        if (event.keyCode === 13) {
            applyAdminSearchFilters()
        }
    });

export const applyAdminSearchFilters = function () {
    document.getElementById("usersForm").submit()
}
export const applyAdminBrokerFilters = function () {
    document.getElementById("brokersForm").submit()
}
export const previousPage = function () {
    let element = document.getElementById('page')
    element.value = parseInt(element.value) - 1
    applyAdminSearchFilters()
}
export const nextPage = function () {
    let element = document.getElementById('page')
    element.value = parseInt(element.value) + 1
    applyAdminSearchFilters()
}
export const removeSearch = function () {
    let element = document.getElementById('searchUser')
    element.value = ''
    applyAdminSearchFilters()
}
export const nextPageBroker = function () {
    let element = document.getElementById('page')
    element.value = parseInt(element.value) + 1
    applyAdminBrokerFilters()
}
export const previousPageBroker = function () {
    let element = document.getElementById('page')
    element.value = parseInt(element.value) - 1
    applyAdminBrokerFilters()
}
export const showBrokerDenialModal = function (id) {
    document.getElementById('broker-id').value = id;
    $("#deny-broker").modal('show');
}
export const makeItInternal = function (id, internal) {
    console.log(id+"->"+internal);
    axios.post('/admin/broker/internal/'+id, {
        internal, internal
    }).then(function (resp) {
        window.location.reload();
    })
}
export const updateBroker = function (id, approved) {
    let modal_title, modal_text, reason = null
    if (approved === 'A') {
        modal_title = 'Broker approved'
        modal_text = 'Broker approved successfully'
        let elementApproval = document.getElementById('approve-broker')
        if (elementApproval)
            elementApproval.classList.add('d-none')
        let elementDenial = document.getElementById('decline-broker')
        if (elementDenial)
            elementDenial.classList.remove('d-none')
    } else {
        modal_title = 'Broker declined'
        modal_text = 'Broker declined successfully'
        document.getElementById('decline-broker').classList.add('d-none')
        $("#deny-broker").modal('hide')
    }
    axios.post('/admin/brokerApproval', {
        id, approved
    }).then(function (resp) {
        console.log("approve status: ", resp);
        if (!resp.data.status) {
            $("#error-modal").modal('show');
            document.getElementById('error-title').innerHTML = "Error processing broker approval";
            document.getElementById('error-body').innerHTML = resp.statusText;
            let statusElement = document.getElementById('broker-status');
            if (statusElement) {
                statusElement.innerHTML = approved === 'A' ? 'Approved' : 'Declined';
            }
        }
    })
}
export const showBrokerDeleteConfirmation = function (id) {
    $("#delete-broker").modal('show')
    var value=document.getElementById('broker_id');
    value.value=id;
  
}
export const deleteBrokers = function (id) {
    var id=document.getElementById('broker_id').value;
    $("#delete-contractor").modal('hide');
    axios.get('/admin/broker/delete', {
      params: {
        id: id
      }
    }).then(function (resp) {
      if (resp.data.status) {
        window.location.reload();
      } else {
        alert('Error occurred while deleting broker');
      }
    })["catch"](function () {
      alert('Error occurred while deleting broker');
    });
};

// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const adminModule = {
    applyAdminSearchFilters,
    applyAdminBrokerFilters,
    previousPage,
    nextPage,
    removeSearch,
    nextPageBroker,
    previousPageBroker,
    showBrokerDenialModal,
    makeItInternal,
    updateBroker,
    showBrokerDeleteConfirmation,
    deleteBrokers,
}
